/**
 * Deployment line shared by the public landing footer and /admin/cogs.
 * Reads the same Vite build injection and index meta tags as the landing page.
 */

import { MAIN_PAGE_FONT_STACK } from "../theme/mainPageVisual";

function readMeta(name: string): string | null {
  if (typeof document === "undefined") {
    return null;
  }
  return (
    document.querySelector(`meta[name="${name}"]`)?.getAttribute("content") ??
    null
  );
}

function formatDeploymentTime(timestamp: string | null): string | null {
  if (!timestamp) return null;
  try {
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZoneName: "short",
    });
  } catch {
    return timestamp;
  }
}

export default function SiteDeploymentStamp() {
  const buildInfo = (typeof window !== "undefined" && window.BUILD_INFO) || {};
  const commit = buildInfo.commit || readMeta("build-commit") || "unknown";
  const builtAt = buildInfo.builtAt || readMeta("build-timestamp") || null;
  const version = buildInfo.version || readMeta("build-version") || "1.0.0";
  const deploymentTime = formatDeploymentTime(builtAt);
  const shortCommit = commit.length > 8 ? commit.substring(0, 8) : commit;

  return (
    <div
      data-testid="site-deployment-stamp"
      style={{
        fontSize: "0.7em",
        marginTop: 10,
        opacity: 0.7,
        fontFamily: MAIN_PAGE_FONT_STACK,
        textAlign: "center",
      }}
    >
      <span>v{version}</span>
      {shortCommit !== "unknown" && (
        <>
          <span style={{ margin: "0 8px" }}>·</span>
          <span title={`Full commit: ${commit}`}>build {shortCommit}</span>
        </>
      )}
      {deploymentTime && (
        <>
          <span style={{ margin: "0 8px" }}>·</span>
          <span title={`Deployed at: ${deploymentTime}`}>
            deployed {deploymentTime}
          </span>
        </>
      )}
    </div>
  );
}
